// src/services/api.js



// const Base_URL = 'http://localhost:1337/api'; // Strapi URL
const Base_URL = process.env.REACT_APP_Base_URL + "/api";

const homePageCache = new Map();
const homePageInflight = new Map();

export const fetchNavbar = async (locale = 'en') => {
  try {
    const res = await fetch(`${Base_URL}/navbar?populate=*&locale=${locale}`);
    const data = await res.json();
    return data.data; // This is the requested language
  } catch (err) {
    console.error('Error fetching home page:', err);
    return null;
  }
};



export const fetchHomePage = async (locale = "en") => {

  // if (homePageCache.has(locale)) return homePageCache.get(locale);
  // if (homePageInflight.has(locale)) return homePageInflight.get(locale);
  if (homePageCache.has(locale)) {

    return homePageCache.get(locale);
  }

  if (homePageInflight.has(locale)) {
   
    return homePageInflight.get(locale);
  }



  const request = fetch(`${Base_URL}/home-page?populate=*&locale=${locale}`)
    .then((res) => res.json())
    .then((data) => {
      homePageInflight.delete(locale);
      if (data?.data != null) homePageCache.set(locale, data.data);
      return data.data;
    })
    .catch((err) => {
      homePageInflight.delete(locale);
      console.error("Error fetching home page:", err);
      return null;
    });

  homePageInflight.set(locale, request);
  return request;
};

export const fetchHomePageTeam = async (locale = 'en') => {
  try {
    const res = await fetch(
      `${Base_URL}/home-page?populate[home_our_Team][populate]=*&locale=${locale}`
    );
    const data = await res.json();
    return data.data;
  } catch (err) {
    console.error('Error fetching home page:', err);
    return null;
  }
};

export const fetchHomePagePortfolio = async (locale = "en") => {
  try {
    const res = await fetch(
      `${Base_URL}/portfolios?populate[company_details][populate][company_image][populate]=*&locale=${locale}`
    );
    const data = await res.json();
    return data.data;
  } catch (err) {
    console.error("Error fetching portfolio:", err);
    return [];
  }
};

export const fetchOurTeamData = async (locale='en') =>{

  try{
      // const res= await fetch(`${Base_URL}/our-teams?populate[home_our_Team][populate]=*&populate[team_link_url]=*&locale=${locale}`);
      const res =  await fetch(    `${Base_URL}/our-teams?populate[Our_Team][populate][team_image][populate]=*&populate[Our_Team][populate][mobile_image][populate]=*&populate[Our_Team][populate][Get_To_Know_More][populate]=*&locale=${locale}`);
      // const res = await fetch(`${Base_URL}/our-team?populate=*&locale=${locale}`);
      const data = await res.json();
    return data.data; // This is the requested language
  } catch (err) {
    console.error('Error fetching portfoliopage:', err);
    return null;
  }
}


export const getLatestArticles = async (page = 1, pageSize = 5, locale ="en") => {
  try {
    const res = await fetch(
      `${Base_URL}/articles-list?page=${page}&pageSize=${pageSize}&locale=${locale}`
    );

    if (!res.ok) {
      throw new Error("Failed to fetch articles");
    }

    const data = await res.json();
    return data;
  } catch (error) {
    console.error("API Error:", error);
    return [];
  }
};


export const fetchFooter = async (locale = 'en') => {
  try {
    const res = await fetch(`${Base_URL}/footer?populate=*&locale=${locale}`);
    const data = await res.json();
    return data.data; // This is the requested language
  } catch (err) {
    console.error('Error fetching footer:', err);
    return null;
  }
};


export const fetchPortfolioPage = async (locale='en') =>{

  try{
    const res = await fetch(`${Base_URL}/portfolio-page?populate=*&locale=${locale}`);
      const data = await res.json();
    return data.data; // This is the requested language
  } catch (err) {
    console.error('Error fetching portfoliopage:', err);
    return null;
  }
}


export const fetchFounderResources = async(locale='en')=>{
  try{
    const res = await fetch(`${Base_URL}/founder-resources?populate[List_item][populate]=Items&locale=${locale}`);
     const data = await res.json();
    return data.data; // This is the requested language
  } catch (err) {
    console.error('Error fetching founder:', err);
    return null;
  }
}

export const fetchLeadershipPage = async (locale='en') =>{

  try{
    const res = await fetch(`${Base_URL}/industry-leadership?populate[Banner_Image]=true&populate[Key_Programs][populate][Image]=true&populate[Industry_list]=true&locale=${locale}`);
      const data = await res.json();
    return data.data; // This is the requested language
  } catch (err) {
    console.error('Error fetching leadership-page:', err);
    return null;
  }
}


export const fetchOurTeam = async (locale='en') =>{

  try{
    const res = await fetch(`${Base_URL}/our-team-page?populate=*&locale=${locale}`);
      const data = await res.json();
    return data.data; // This is the requested language
  } catch (err) {
    console.error('Error fetching portfoliopage:', err);
    return null;
  }
}




export const fetchContactPage = async (locale='en') =>{

  try{
    const res = await fetch(`${Base_URL}/contact-page?populate=*&locale=${locale}`);
      const data = await res.json();
    return data.data; // This is the requested language
  } catch (err) {
    console.error('Error fetching portfoliopage:', err);
    return null;
  }
}


export const fetchInvestementPage = async (locale='en') =>{

  try{
    const res = await fetch(`${Base_URL}/investment-thesis?populate=*&locale=${locale}`);
      const data = await res.json();
    return data.data; // This is the requested language
  } catch (err) {
    console.error('Error fetching portfoliopage:', err);
    return null;
  }
}
export const getArticleBySlug = async (slug, locale = "en") => {
  const response = await fetch(
    `${process.env.REACT_APP_Base_URL}/api/articles-detail/${slug}?locale=${locale}`
  );

  if (!response.ok) throw new Error("Article not found");

  const json = await response.json();
  return json || null;
};

// export const getArticleBySlug = async (slug, locale = "en") => {
//   const response = await fetch(
//   `${process.env.REACT_APP_Base_URL}/api/articles?filters[slug][$eq]=${slug}&locale=${locale}&populate=*`
// );

//   if (!response.ok) throw new Error("Article not found");

//   const json = await response.json();

//   // Strapi returns array inside data
//   const article = json.data?.[0] || null;

//   if (!article) throw new Error("Article not found");

//   return article;
// };




export const fetchPageSeo = (slug, lang = "en") => {
  return fetch(
    `${process.env.REACT_APP_Base_URL}/api/page-seos?filters[page_slug][$eq]=${slug}&locale=${lang}&populate=*`
  )
    .then((res) => res.json())
    .then((data) => data?.data?.[0] || null)
    .catch(() => null);
};